module.exports = __webpack_public_path__ + "img/438bc35.jpg";